export const ORIGIN = {
  C010: { value: 'C010', label: 'stock.c010' },
  C050: { value: 'C050', label: 'stock.c050' },
  C060: { value: 'C060', label: 'stock.c060' },
  C070: { value: 'C070', label: 'stock.c070' },
  C080: { value: 'C080', label: 'stock.c080' },
}

export const DESTINY = {
  C010: { value: 'C010', label: 'stock.c010' },
  C050: { value: 'C050', label: 'stock.c050' },
  C060: { value: 'C060', label: 'stock.c060' },
  C070: { value: 'C070', label: 'stock.c070' },
  C080: { value: 'C080', label: 'stock.c080' },
}
